import { useState } from 'react';
import {
  mapGlobalSearchResultsGroupType,
  useFindGlobalSearchResults,
} from '@api';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Loader } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
import { openSpotlight, Spotlight } from '@mantine/spotlight';
import { useTranslation } from 'react-i18next';
import { ActionGroup, SpotlightButton } from './components';

const TRANS_KEY = 'HEADER.SPOTLIGHT_SEARCH';

export const SpotlightSearch: React.FC = () => {
  const { t } = useTranslation();

  const [query, setQuery] = useState('');
  const [debouncedQuery] = useDebouncedValue(query, 300);

  const { data: globalSearchResults = [], isLoading } =
    useFindGlobalSearchResults(
      {
        search: debouncedQuery,
      },
      {
        query: {
          enabled: debouncedQuery.length > 0,
          select: (data) => mapGlobalSearchResultsGroupType(data.data),
        },
      }
    );

  const getNothingFound = () => {
    if (isLoading) return <Loader />;
    if (debouncedQuery === '') return t(`${TRANS_KEY}.EMPTY_SEARCH`);
    return t('NOTHING_FOUND');
  };

  const isEmptySearch = globalSearchResults.every(
    (group) => group.results.length === 0
  );

  return (
    <>
      <SpotlightButton onClick={openSpotlight} />
      <Spotlight.Root query={query} onQueryChange={setQuery} scrollable>
        <Spotlight.Search
          leftSection={<FontAwesomeIcon icon={faSearch} size="lg" />}
          placeholder={t(`${TRANS_KEY}.PLACEHOLDER`)}
        />
        <Spotlight.ActionsList>
          {globalSearchResults.map((group) => (
            <ActionGroup key={group.id} group={group} />
          ))}
          {isEmptySearch && (
            <Spotlight.Empty>{getNothingFound()}</Spotlight.Empty>
          )}
        </Spotlight.ActionsList>
      </Spotlight.Root>
    </>
  );
};
